import { render, staticRenderFns } from "./ContentPagesTable.vue?vue&type=template&id=f6f54b86&scoped=true&"
import script from "./ContentPagesTable.vue?vue&type=script&lang=js&"
export * from "./ContentPagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f54b86",
  null
  
)

export default component.exports